module.exports = __webpack_public_path__ + "img/logo_redes_blanco.61a77854.png";